var map = {
	"./about-image.png": "f6b3",
	"./arrow-down.png": "82e3",
	"./bg-call.png": "ccad",
	"./bg-guarantee.png": "86bc",
	"./bg-header.png": "9be6",
	"./bg-stage.png": "181f",
	"./calc-1.png": "7fc5",
	"./calc-2.png": "f9c6",
	"./calc-3.png": "6e11",
	"./calc-4.png": "1125",
	"./calc-5.png": "b83e",
	"./contact-adress.png": "fdec",
	"./contact-email.png": "b4c5",
	"./contact-phone.png": "79c4",
	"./icon-about-1.png": "b511",
	"./icon-about-2.png": "e1d1",
	"./icon-about-3.png": "4604",
	"./icon-about-4.png": "bfe3",
	"./icon-arrow.png": "c2e4",
	"./icon-delete.png": "2d71",
	"./icon-minus.png": "5cac",
	"./icon-plus.png": "70ce",
	"./inp_mail.png": "7ea6",
	"./inp_name.png": "a2c5",
	"./inp_phone.png": "1d24",
	"./line.png": "2eed",
	"./logo-header.png": "a177",
	"./map.png": "ce8a",
	"./product-1.png": "8ee3",
	"./product-2.jpg": "8a29",
	"./product-3.jpg": "617c",
	"./product-4.jpg": "af1e",
	"./product-5.jpg": "785c",
	"./stage-arrow.png": "a9df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b809";